import styled from '@emotion/styled'

export const RedHeader = styled.span`
  color: #f00;
`
